import { Location } from 'history'

const getPathByLocation = (location: Location): string => `${location.pathname}${location.search}${location.hash}`

export default getPathByLocation
